const Footer = () => {
  return (
    <div>
      <br/>
      <br/>
      <footer id="footer" className="fixed-bottom" >
          <div className="text-center p-3">
            Developed by Marshall & Co, 2024
          </div>
      </footer>
    </div>
  )
}

export default Footer